import axios from '../../axios/index.js'

export default {
  fetchData(payload) {
    return axios.get(`data/?type=${payload.type}&dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}`)
  },
  fetchXMLData(payload) {
    return axios.get(`data/shortterm?dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}`)
  },
  fetchLongParkingData(payload) {
    return axios.get(`data/longterm?dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}`)
  },
  fetchFileList() {
    return axios.get(`data/filelist`)
  },
  deleteFileByID(fileID) {
    return axios.delete(`data/file/${fileID}`)
  },
  uploadXlsxFile(payload) {
    var formData = new FormData()
    formData.append('file', payload.file)
    var headers = {'Content-Type': 'multipart/form-data'}
    return axios.post(`data/upload/xlsx`, formData, {headers})
  },
  uploadXmlFile(payload) {
    var formData = new FormData()
    formData.append('file', payload.file)
    var headers = {'Content-Type': 'multipart/form-data'}
    return axios.post(`data/upload/xml`, formData, {headers})
  }
}
